export enum WebsocketListener {
    REACTIONS = '/reactions',
    WATCH_PARTY = '/watch-party',
    COMMENTS = '/event'
  }